import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    getAllEmptyViewModels,
    overrideComponent,
    postVerificationSizeUpdates,
    setMetadata,
    setOptions,
    setViewModel,
    StudentPersonalInfoViewModel,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { getQueryParamsByName } from './lib/utils/browser';
import { StepStudentPersonalInfoComponent } from './components/Steps/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/Steps/StepSuccessComponent';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

const redirectURL = getQueryParamsByName('redirectURL') || 'https://www.backmarket.com';
const userid = getQueryParamsByName('userid') || '';
setMetadata({
    redirectURL,
    userid,
});

const defaultViewModel: StudentPersonalInfoViewModel = getAllEmptyViewModels().collectStudentPersonalInfo as StudentPersonalInfoViewModel;
defaultViewModel.localeChoice = { value: 'en-US', label: 'English' };
setViewModel(defaultViewModel);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
